<div #chart style="height: 35vh; width: 100%"></div>